import { render } from "./VoucherOrder.vue?vue&type=template&id=993af8fe&scoped=true"
import script from "./VoucherOrder.vue?vue&type=script&lang=js"
export * from "./VoucherOrder.vue?vue&type=script&lang=js"

import "./VoucherOrder.vue?vue&type=style&index=0&id=993af8fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-993af8fe"

export default script